import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER;
const ctx = { product: null, listeners: new Set() };

export const setWhatsAppProduct = (title) => {
  ctx.product = title;
  ctx.listeners.forEach((fn) => fn(title));
};

const WaIcon = () => (
  <svg viewBox="0 0 32 32" width="26" height="26" fill="currentColor" aria-hidden="true">
    <path d="M16.04 3C9.4 3 4 8.36 4 14.97c0 2.11.56 4.17 1.62 5.99L4 29l8.25-1.6a12.1 12.1 0 0 0 3.79.6C22.68 28 28 22.64 28 16.03 28 9.42 22.68 3 16.04 3Zm0 22.9c-1.2 0-2.38-.2-3.5-.58l-.25-.09-4.9.95.96-4.73-.16-.26a9.8 9.8 0 0 1-1.52-5.22c0-5.47 4.48-9.92 9.98-9.92 5.48 0 9.94 4.45 9.94 9.98 0 5.5-4.46 9.87-9.94 9.87Zm5.45-7.4c-.3-.15-1.77-.87-2.04-.97-.28-.1-.48-.15-.68.15-.2.3-.78.97-.96 1.17-.18.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.76-1.66-2.06-.17-.3-.02-.46.13-.61.14-.14.3-.35.45-.52.15-.18.2-.3.3-.5.1-.2.05-.38-.02-.53-.08-.15-.68-1.63-.93-2.23-.24-.58-.5-.5-.68-.51h-.58c-.2 0-.53.08-.8.38-.28.3-1.05 1.02-1.05 2.5 0 1.47 1.08 2.9 1.23 3.1.15.2 2.12 3.23 5.13 4.53.72.31 1.28.5 1.71.63.72.23 1.38.2 1.9.12.58-.09 1.77-.72 2.02-1.42.25-.7.25-1.3.18-1.42-.08-.12-.28-.2-.58-.35Z" />
  </svg>
);

export const WhatsAppButton = () => {
  const { pathname } = useLocation();
  const [product, setProduct] = useState(ctx.product);
  useEffect(() => {
    ctx.listeners.add(setProduct);
    return () => ctx.listeners.delete(setProduct);
  }, []);
  if (!NUMBER || pathname.startsWith("/admin") || pathname.startsWith("/influencer")) return null;
  const onProduct = pathname.startsWith("/prodotto/") && product;
  const text = onProduct ? `Ciao Minime Baby! Ho una domanda su "${product}"` : "Ciao Minime Baby! Ho una domanda";
  const lifted = pathname.startsWith("/scuola/") ? "bottom-36 sm:bottom-28" : "bottom-20 lg:bottom-6";
  return (
    <a data-testid="whatsapp-contact" href={`https://wa.me/${NUMBER}?text=${encodeURIComponent(text)}`}
      target="_blank" rel="noreferrer" aria-label="Scrivici su WhatsApp"
      className={`fixed right-4 sm:right-6 ${lifted} z-40 w-14 h-14 rounded-full bg-[#25D366] text-white shadow-lg flex items-center justify-center hover:scale-105 transition-transform`}>
      <WaIcon />
    </a>
  );
};
